// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__2C7Kj","right":"styles_right__3jZPs"};